import {
  BASE_API_URL,
  post,
} from '@/utils/http'

export * from './common'
export const queryBannerUrl = `${BASE_API_URL}/sy/queryLbtList`
export const queryBanner = (...args) => {
  return post(queryBannerUrl, ...args)
}

export const queryServiceUrl = `${BASE_API_URL}/sy/queryDhfwList`
export const queryService = (...args) => {
  return post(queryServiceUrl, ...args)
}

export const queryNoticeUrl = `${BASE_API_URL}/sy/queryGgList`
export const queryNotice = (...args) => {
  return post(queryNoticeUrl, ...args)
}

export const queryNoticeDetailUrl = `${BASE_API_URL}/sy/queryGgDetail`
export const queryNoticeDetail = (...args) => {
  return post(queryNoticeDetailUrl, ...args)
}

export const queryMessageUrl = `${BASE_API_URL}/xx/queryXxZnList`
export const queryMessage = (...args) => {
  return post(queryMessageUrl, ...args)
}

export const updateMessageUrl = `${BASE_API_URL}/xx/updateXxZnYd`
export const updateMessage = (...args) => {
  return post(updateMessageUrl, ...args)
}

export const queryMessageDetailUrl = `${BASE_API_URL}/xx/queryXxZnDetail`
export const queryMessageDetail = (...args) => {
  return post(queryMessageDetailUrl, ...args)
}

// 查询分组服务
export const queryServiceByGroupUrl = `${BASE_API_URL}/fw/queryFzfwList`
export const queryServiceByGroup = (...args) => {
  return post(queryServiceByGroupUrl, ...args)
}

export const searchServiceContentUrl = `${BASE_API_URL}/fw/queryFwnr`
export const searchServiceContent = (...args) => {
  return post(searchServiceContentUrl, ...args)
}

// 登录
export const doLoginUrl = `${BASE_API_URL}/dl/login`
export const doLogin = (...args) => {
  return post(doLoginUrl, ...args)
}

export const queryLoginMessageUrl = `${BASE_API_URL}/dl/queryLoginMessage`
export const queryLoginMessage = (...args) => {
  return post(queryLoginMessageUrl, ...args)
}

export const querySfxsbmxxUrl = `${BASE_API_URL}/dl/querySfxsbmxx`
export const querySfxsbmxx = (...args) => {
  return post(querySfxsbmxxUrl, ...args)
}

export const uploadPhotoUrl = `${BASE_API_URL}/dl/uploadPhoto`
export const uploadPhoto = (...args) => {
  return post(uploadPhotoUrl, ...args)
}

export const queryUserInfoUrl = `${BASE_API_URL}/dl/queryUserInfo`
export const queryUserInfo = (...args) => {
  return post(queryUserInfoUrl, ...args)
}

export const doLogoutUrl = `${BASE_API_URL}/dl/logout`
export const doLogout = (...args) => {
  return post(doLogoutUrl, ...args)
}

export const doModifyPasswordUrl = `${BASE_API_URL}/dl/modifyPassword`
export const doModifyPassword = (...args) => {
  return post(doModifyPasswordUrl, ...args)
}

export const queryRegisterConfigUrl = `${BASE_API_URL}/zc/queryRegisterConfig`
export const queryRegisterConfig = (...args) => {
  return post(queryRegisterConfigUrl, ...args)
}

export const doRegisterUrl = `${BASE_API_URL}/zc/register`
export const doRegister = (...args) => {
  return post(doRegisterUrl, ...args)
}

export const queryWeChatUrl = `${BASE_API_URL}/wx/queryWechatAuthUrl`
export const queryWeChat = (...args) => {
  return post(queryWeChatUrl, ...args)
}

export const findPasswordValidateUrl = `${BASE_API_URL}/zc/findPasswordValidate`
export const findPasswordValidate = (...args) => {
  return post(findPasswordValidateUrl, ...args)
}

export const updatePasswordUrl = `${BASE_API_URL}/zc/updatePassword`
export const updatePassword = (...args) => {
  return post(updatePasswordUrl, ...args)
}

export const queryNeedCheckIdentifyUrl = `${BASE_API_URL}/ykhy/queryYkSfkthy`
export const queryNeedCheckIdentify = (...args) => {
  return post(queryNeedCheckIdentifyUrl, ...args)
}

export const queryCheckIdentifyStatusUrl = `${BASE_API_URL}/ykhy/queryYkSfshzt`
export const queryCheckIdentifyStatus = (...args) => {
  return post(queryCheckIdentifyStatusUrl, ...args)
}

export const queryOpenPhoneMessageUrl = `${BASE_API_URL}/ykhy/queryYkSfSfxydx`
export const queryOpenPhoneMessage = (...args) => {
  return post(queryOpenPhoneMessageUrl, ...args)
}

export const sendPhoneCodeUrl = `${BASE_API_URL}/ykhy/sendVerifyCode`
export const sendPhoneCode = (...args) => {
  return post(sendPhoneCodeUrl, ...args)
}

export const sendRegisterPhoneCodeUrl = `${BASE_API_URL}/zc/sendVerifyCode`
export const sendRegisterPhoneCode = (...args) => {
  return post(sendRegisterPhoneCodeUrl, ...args)
}

export const sendPasswordPhoneCodeUrl = `${BASE_API_URL}/zc/sendPasswordVerifyCode`
export const sendPasswordPhoneCode = (...args) => {
  return post(sendPasswordPhoneCodeUrl, ...args)
}

export const checkPhoneCodeUrl = `${BASE_API_URL}/ykhy/checkVerifyCode`
export const checkPhoneCode = (...args) => {
  return post(checkPhoneCodeUrl, ...args)
}

export const queryOpenIdentifyUrl = `${BASE_API_URL}/ykhy/queryYkSfhysfxyzj`
export const queryOpenIdentify = (...args) => {
  return post(queryOpenIdentifyUrl, ...args)
}

export const uploadIdentifyPhoneUrl = `${BASE_API_URL}/ykhy/uploadPhoto`
export const uploadIdentifyPhone = (...args) => {
  return post(uploadIdentifyPhoneUrl, ...args)
}

export const recognitionIdCardUrl = `${BASE_API_URL}/ykhy/recognitionIdCard`
export const recognitionIdCard = (...args) => {
  return post(recognitionIdCardUrl, ...args)
}

export const uploadCard1Url = `${BASE_API_URL}/ykhy/uploadIdCard1`
export const uploadCard1 = (...args) => {
  return post(uploadCard1Url, ...args)
}

export const uploadCard2Url = `${BASE_API_URL}/ykhy/uploadIdCard2`
export const uploadCard2 = (...args) => {
  return post(uploadCard2Url, ...args)
}

export const queryCheckIdentityJumpStatusUrl = `${BASE_API_URL}/ykhy/queryYkSfhysfxyht`
export const queryCheckIdentityJumpStatus = (...args) => {
  return post(queryCheckIdentityJumpStatusUrl, ...args)
}
